<template>
  <div class="row align-items-center pt-2 pb-2 border-top" >
<div class="col-sm-6">
        <span class>{{ labelText }}</span>
      </div>
      <div class="col-sm-6">
       <numerictextbox
       class="w-50"
      type="number"
      :name="fieldName"
      :value="value"
      @input="$emit('input', $event.target.value)"
      :placeholder="placeholder"
    ></numerictextbox>
   
      </div>
      </div>

  <!-- <div class="col-4 mb-3">
    <label>{{ labelText }}</label>

    <numerictextbox
      type="number"
      :name="fieldName"
      :value="value"
      @input="$emit('input', $event.target.value)"
      :placeholder="placeholder"
    ></numerictextbox>
  </div> -->
</template>
<script>
export default {
  name: "NumberInput",
  props: ["placeholder", "labelText", "fieldName", "value"],
};
</script>
